<template>
  <BaseFormLayout
    :title="`Add ${stepperList[stepperFrom - 1]}`"
    contentClass="px-0 pt-4 "
  >
    <template #actions>
      <SecondaryButton
        id="companiesReset"
        @click="resetForm()"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
      >
      </SecondaryButton>
      <PrimaryButton
        id="companiesSubmit"
        btnClass="text-uppercase rounded-lg mr-2"
        name="Submit & Add Another"
        v-if="stepperFrom == 3 || stepperFrom == 4"
        @click="submitAnotherForm()"
      >
      </PrimaryButton>
      <PrimaryButton
        id="companiesSubmit"
        btnClass="text-uppercase rounded-lg"
        name="Submit"
        @click="submitForm()"
      >
      </PrimaryButton>
    </template>
    <template #content>
      <v-stepper v-model="stepperFrom" elevation="0" class="background_color">
        <v-stepper-header class="mx-4 white rounded-lg" style="box-shadow:none">
          <v-stepper-step
            step="1"
            :complete="stepperFrom > 1"
            :color="
              1 <= stepperFrom && stepperFrom != 1 ? 'success' : 'primary'
            "
            >Company</v-stepper-step
          >
          <v-stepper-step
            @click="stepMove(2)"
            step="2"
            :complete="stepperFrom > 2"
            :color="
              2 <= stepperFrom && stepperFrom != 2 ? 'success' : 'primary'
            "
            >Account Admin</v-stepper-step
          >
          <v-stepper-step
            @click="stepMove(3)"
            step="3"
            :complete="stepperFrom > 3"
            :color="
              3 <= stepperFrom && stepperFrom != 3 ? 'success' : 'primary'
            "
            >Branch</v-stepper-step
          >
          <v-stepper-step
            @click="stepMove(4)"
            step="4"
            :color="
              4 <= stepperFrom && stepperFrom != 4 ? 'success' : 'primary'
            "
            :complete="stepperFrom > 4"
            >Warehouse</v-stepper-step
          >
          <v-stepper-step
            @click="stepMove(5)"
            step="5"
            :color="
              5 <= stepperFrom && stepperFrom != 5 ? 'success' : 'primary'
            "
            :complete="stepperFrom > 5"
            >Project</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-items
          class="background_color pa-0 ba"
          style="height: calc(100vh - 235px) !important"
        >
          <v-stepper-content step="1" class="pa-0">
            <CompanyForm
              :editMode="false"
              v-if="stepperFrom == 1"
              @redirect="redirect"
              :isHeader="false"
              ref="companyForm"
            />
          </v-stepper-content>
          <v-stepper-content step="2" class="pa-0">
            <AccountAdminForm
              v-if="stepperFrom == 2"
              :editMode="false"
              :isHeader="false"
              @redirect="redirect"
              ref="accountAdminForm"
            />
          </v-stepper-content>
          <v-stepper-content step="3" class="pa-0">
            <BranchForm
              :editMode="false"
              :isHeader="false"
              v-if="stepperFrom == 3"
              @redirect="redirect"
              ref="branchForm"
            />
          </v-stepper-content>
          <v-stepper-content step="4" class="pa-0">
            <WarehouseForm
              :editMode="false"
              v-if="stepperFrom == 4"
              :isHeader="false"
              @redirect="redirect"
              ref="warehouseForm"
            />
          </v-stepper-content>
          <v-stepper-content step="5" class="pa-0">
            <ProjectForm
              :editMode="false"
              :isHeader="false"
              v-if="stepperFrom == 5"
              @redirect="redirect"
              ref="projectForm"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>
  </BaseFormLayout>
</template>

<script>
import CompanyForm from "@/components/ModuleBasedComponents/Company/CompanyForm.vue";
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import AccountAdminForm from "@/components/ModuleBasedComponents/AccountAdmin/AccountAdminForm.vue";
import BranchForm from "@/components/ModuleBasedComponents/Branch/BranchForm.vue";
import WarehouseForm from "@/components/ModuleBasedComponents/Warehouse/WarehouseForm.vue";
import ProjectForm from "@/components/ModuleBasedComponents/Project/ProjectForm.vue";
import DriverForm from "@/components/ModuleBasedComponents/Driver/DriverForm.vue";

export default {
  components: {
    CompanyForm,
    BaseFormLayout,
    AccountAdminForm,
    BranchForm,
    WarehouseForm,
    ProjectForm,
    DriverForm,
  },
  data() {
    return {
      stepperFrom: 1,
      currentStep: null,
      isSubmitAnotherForm: false,
      stepperList: [
        "Company",
        "Account Admin",
        "Branch",
        "Warehouse",
        "Project",
      ],
    };
  },

  methods: {
    stepMove(step) {
      if (step <= this.currentStep) {
        this.stepperFrom = step;
      }
    },
    resetForm() {
      if (this.stepperFrom == 1) {
        this.$refs.companyForm.resetForm();
      } else if (this.stepperFrom == 2) {
        this.$refs.accountAdminForm.resetForm();
      } else if (this.stepperFrom == 3) {
        this.$refs.branchForm.resetForm();
      } else if (this.stepperFrom == 4) {
        this.$refs.warehouseForm.resetForm();
      } else if (this.stepperFrom == 5) {
        this.$refs.projectForm.resetForm();
      }
    },
    submitAnotherForm() {
      this.isSubmitAnotherForm = true;
      this.submitForm();
    },
    submitForm() {
      if (this.stepperFrom == 1) {
        this.$refs.companyForm.submitForm();
      } else if (this.stepperFrom == 2) {
        this.$refs.accountAdminForm.submitForm();
      } else if (this.stepperFrom == 3) {
        this.$refs.branchForm.submitForm();
      } else if (this.stepperFrom == 4) {
        this.$refs.warehouseForm.submitForm();
      } else if (this.stepperFrom == 5) {
        this.$refs.projectForm.submitForm();
      }
    },
    getCompanyObject(id) {
      this.$api.company
        .getCompanyObject(id)
        .then((res) => {
          this.stepperFrom = res.data.no_of_step_completed + 1;
          this.currentStep = res.data.no_of_step_completed + 1;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    redirect(val, data = {}) {
      if (data && data.company) {
        this.$router.push({
          name: "add-company",
          query: { companyId: data.company },
        });
      }
      if (val) {
        if (this.stepperFrom == 3) {
          if (!this.isSubmitAnotherForm) {
            this.stepperFrom += 1;
          } else {
            this.isSubmitAnotherForm = false;
          }
        } else if (this.stepperFrom == 4) {
          if (!this.isSubmitAnotherForm) {
            this.stepperFrom += 1;
          } else {
            this.isSubmitAnotherForm = false;
          }
        } else if (this.stepperFrom == 5) {
          this.$router.push({ name: "company" });
        } else {
          this.stepperFrom += 1;
        }
      }
    },
  },
  async mounted() {
    if ("companyId" in this.$route.query) {
      await this.getCompanyObject(this.$route.query.companyId);
    }
  },
};
</script>

<style>
.v-select__slot label {
  z-index: 2;
}
</style>
